/**
 * @file sonner.component.tsx
 * @path packages/ui/src/sonner.component.tsx
 * @description
 */

import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            // CARD STYLE:
            // Border-2, Rounded-XL, Shadow-LG.
            // It looks like a physical card popping up.
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-2 group-[.toaster]:border-border group-[.toaster]:rounded-xl group-[.toaster]:shadow-xl",

          description: "group-[.toast]:text-muted-foreground",

          actionButton:
            // BUTTON STYLE:
            // Green Hard Bezel (Accent)
            "group-[.toast]:neuro-bezel group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:font-semibold",

          cancelButton:
            // BUTTON STYLE:
            // Soft Well (Secondary)
            "group-[.toast]:neuro-well group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:border group-[.toast]:border-input",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
